import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'

const categories = ['Technology', 'Business', 'Product', 'Data & Intelligence', 'Digital Commerce']

export function InsightsPreview() {
  return (
    <section className="border-b border-ink/10 bg-bone py-24 md:py-32">
      <Container>
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <Eyebrow>Insights</Eyebrow>
            <h2 className="mt-6 max-w-xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
              Thinking beyond the build.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-graphite">
              Ideas, research, and observations about technology, business, digital products, data,
              intelligence, and the systems shaping how organizations operate.
            </p>
          </Reveal>
          <Reveal delay={100}>
            <CTA to="/insights" variant="ghost">
              Explore insights
            </CTA>
          </Reveal>
        </div>

        <Reveal delay={150}>
          <div className="mt-14 flex flex-wrap gap-3">
            {categories.map((category) => (
              <span
                key={category}
                className="rounded-full border border-ink/15 bg-paper px-4 py-2 text-xs font-medium uppercase tracking-wide text-ink/70"
              >
                {category}
              </span>
            ))}
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
